module.exports = __webpack_public_path__ + "static/media/giftsSent_5000.096e2b66.png";